let showHideLangTimeout;

function showHideLang () {

  clearTimeout(showHideLangTimeout);

  if ( window.scrollY < window.innerHeight / 3 ) {
    document.getElementsByClassName('store-chooselang')[0].style.zIndex = '2';
    document.getElementsByClassName('store-chooselang')[0].style.opacity = '1';
  } else {
    showHideLangTimeout = setTimeout( () => { document.getElementsByClassName('store-chooselang')[0].style.zIndex = '-1'; }, 600);
    document.getElementsByClassName('store-chooselang')[0].style.opacity = '0';
  }
  
}

